import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-358e5130"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper-header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-bars el-icon-2x fas" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/img/logo.png",
    alt: "xaqmonicas"
  })
], -1))
const _hoisted_4 = { class: "app" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "links" }, null, -1))
const _hoisted_6 = { class: "alerts" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-bell fas" }, null, -1))
const _hoisted_8 = { class: "user" }
const _hoisted_9 = { class: "el-dropdown-link" }
const _hoisted_10 = { class: "hidden-sm-and-down" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "fas el-icon-caret-down" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_badge = _resolveComponent("el-badge")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.collapsable)
      ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          text: "",
          onClick: _ctx.collapseChage,
          class: "btn-collapse"
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["onClick"]))
      : _createCommentVNode("", true),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.app), 1),
    _hoisted_5,
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_el_badge, {
        hidden: !_ctx.notifications,
        value: _ctx.notifications,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToAlerts())),
        class: _normalizeClass(_ctx.notificationCss),
        title: _ctx.$t('info.notificationNumber', { number: _ctx.notifications, minutes: 60 })
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_button, null, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["hidden", "value", "class", "title"])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_el_dropdown, {
        class: "user-name",
        trigger: "click",
        onCommand: _ctx.handleCommand
      }, {
        dropdown: _withCtx(() => [
          _createVNode(_component_el_dropdown_menu, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_dropdown_item, { command: "loginout" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("btn.logout")), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_9, [
            _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.username), 1),
            _hoisted_11
          ])
        ]),
        _: 1
      }, 8, ["onCommand"])
    ])
  ]))
}